/**
 * descption
 * author: CarloHsu TGFE
 * Date: 2019/9/23
 * Time: 2:40 下午
 *
 */

import Vue from 'vue';
import options from './index.vue';

Vue.component('tg-award', options);